import React from 'react';
import './Header.css';
import Nav from '../Nav/Nav';

class Header extends React.Component {
  render() {
    return (
      <header>
        <div className="main-header">
          <div className="container">
            <h1 className="site-title">React Lite Level</h1>
            <Nav link={this.props.link} />
          </div>
        </div>
      </header>
    );
  }
}

export default Header;
